import { render, staticRenderFns } from "./SelectCarteira.vue?vue&type=template&id=98b6f484&scoped=true"
import script from "./SelectCarteira.vue?vue&type=script&lang=js"
export * from "./SelectCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6f484",
  null
  
)

export default component.exports